<template>
  <v-container fluid class ="py-0">
    <v-row class="grey lighten-2">
      <v-card flat color="transparent" class="mx-auto py-12 text-center" >
        <v-card-title class="display-1 mb-2">{{ title }}</v-card-title>
      </v-card>
    </v-row>
    <v-row>
      <v-card flat color="transparent" class="mx-auto my-12 text-center" >
        <v-card-title class="headline mb-2">{{ subtitle }}</v-card-title>
      </v-card>
    </v-row>
    <v-row v-if="content">
      <v-spacer></v-spacer>
      <v-col>
      <v-card :width="isMobile?350:700" flat color="transparent" class="mx-auto pb-12 text-center" >
        <v-card-text class="mb-2">{{ content }}</v-card-text>
      </v-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-img v-if="imgUrl" :max-width="isMobile?350:700" :src="imgUrl"></v-img>
      <v-spacer></v-spacer>
    </v-row>
    <slot></slot>
  </v-container>
</template>

<script>
export default {
    name: 'TciServiceHead',
    data: () => ({
      isMobile:false
    }),
    props: {
      title: String,
      subtitle: String,
      content: String,
      imgUrl: String
    },
    mounted() {
      this.isMobile=this.$vuetify.breakpoint.xs;
    }
}
</script>
